import other from './other'

export default other
